<ng-container [ngSwitch]="localConfig.valueFormat" >
    <app-input-edit-percentage
        *ngSwitchCase="'Percentage'"
        [formControl]="control"
        [config]="localConfig"
        [errorState]="errorState">
    </app-input-edit-percentage>
    <mat-form-field 
        *ngSwitchDefault
        class="mat-field-width">
        <input matInput 
                [formControl]="control"
                type="{{localConfig.controlDataType}}"
                placeholder="{{localConfig.label}}" 
                [errorStateMatcher]="errorState"/>
        <span matSuffix *ngIf="localConfig.tooltip">
            <app-field-tooltip-suffix [tooltip]="localConfig.tooltip" ></app-field-tooltip-suffix>
        </span>
        <mat-error>
            <span>{{localConfig.validation}}</span>
        </mat-error>
    </mat-form-field>    
</ng-container>
